import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import ModalPage from "../explore/layout/ModalPage";
import { setShowErrorListModal } from 'store/actions';

const ErrorMessageListModal = ({
  errorListModalState,
  showErrorListModal,
  setShowErrorListModal
}) => {

  const onClose = () =>  {
    setShowErrorListModal(false)
  }

  return (
    <ModalPage
      maxWidth="md"
      title=""
      open={showErrorListModal === true}
      onClose={onClose}
      additionalActions={[
        {
          key: "btnClose",
          text: "Close",
          color: "primary",
          onClick: onClose,
        },
      ]}
    >

    <div style={{fontSize: 20, fontWeight: 'bold', marginBottom: 20}}>{errorListModalState?.header}</div>

    <ul>
      {errorListModalState?.details.map(errorString => {
        return (
          <li>{errorString}</li>
        )
      })}
    </ul>

    </ModalPage>
  )
}

const mapStateToProps = state => ({
  errorListModalState: state.appState.errorListModalState,
  showErrorListModal: state.appState.showErrorListModal
})

const mapDispatchToProps = {
  setShowErrorListModal
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ErrorMessageListModal);